import axios, { AxiosResponse } from 'axios';

import { productAPI } from './api';

export async function getProductDetail(
  productId: string,
  countryCode: string,
  locale: string,
): Promise<AxiosResponse> {
  const endpoint = `/detail/${productId}/${countryCode.toUpperCase()}/${locale.substring(0, 2)}`;

  try {
    return await productAPI().get(endpoint);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response;
    }
    throw new Error(`Product not found ${productId}`);
  }
}
